var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authentication"},[_c('router-view'),_c('Footer',{attrs:{"show-divider":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }